import { useToken } from "@gluestack-style/react";
import { Box, Button, HStack, Icon, Link, Paragraph } from "components/ui";
import { Download, File } from "lucide-react-native";
import React, { ComponentProps } from "react";

type Props = ComponentProps<typeof Button> & {
	title: string;
	url: string;
	isFile?: boolean;
};

const ItemDownload: React.FC<Props> = ({ title, url, isFile, ...buttonProps }) => {
	const resolvedPrimarylight = useToken("colors", "primarylight");
	return (
		<Link href={url} target="download">
			<Box flexDirection="row" bg="$neutral35" borderRadius={12} w="$full" paddingHorizontal={24} paddingVertical={28}>
				<HStack gap={12} justifyContent="center">
					{isFile && <File color={resolvedPrimarylight} />}

					<Paragraph
						sx={{
							fontFamily: "calibri",
						}}
					>
						{title}
					</Paragraph>
				</HStack>
				<HStack alignItems="center" gap={8} marginLeft={"auto"}>
					<Icon as={Download} color="$basicblack" />
				</HStack>
			</Box>
		</Link>
	);
};

export default ItemDownload;
